let apiKey = '';

// التحقق من وجود النافذة (أي أننا في متصفح وليس في خادم)
if (typeof window !== 'undefined' && window.ENV_CONFIG) {
  try {
    apiKey = window.ENV_CONFIG.getGoogleMapsKey();
  } catch (error) {
    console.error('خطأ في الحصول على مفتاح خرائط Google');
    
    // استخدام المتغير البيئي كنسخة احتياطية
    apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '';
  }
} else {
  // استخدام المتغير البيئي إذا كنا في بيئة الخادم
  apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '';
}

export const GOOGLE_MAPS_CONFIG = {
  apiKey,
  version: 'weekly',
  libraries: ['places'],
  language: 'ar',
  region: 'KW'
};

export const MAP_DEFAULTS = {
  center: { lat: 29.3759, lng: 47.9774 },
  zoom: 12,
  options: {
    streetViewControl: false,
    fullscreenControl: false,
    mapTypeControl: false,
    zoomControl: true,
    scrollwheel: true,
    disableDoubleClickZoom: false,
    maxZoom: 18,
    minZoom: 8
  }
}; 